import { Link } from 'react-router-dom';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from '../../../assets/images/logo.png';
import Arrow from '../../../assets/images/back-arrow.png'
import IndividualIcon from '../../../assets/images/individual.png';
import CorporateIcon from '../../../assets/images/corporate.png';
import VendorIcon from '../../../assets/images/vendor.png';
import { RoleCard } from '../../../components/RoleCard';
import { useMobile } from '../../../hooks/useMobile';

export const RoleSelectionPage = () => {
    
    const isMobile = useMobile();

const [selectedRole, setSelectedRole] = useState(null);
  const navigate = useNavigate();

  const handleContinue = () => {
    if (selectedRole) {
      navigate(`/signup/${selectedRole}`);
    }
  };

    return (
        <div style={{ margin: '50px auto 80px', width: isMobile ? '95%' : '90%' }}>
            <Link to='/account' style={{ 
                    color: '#1F2933',
                    textDecoration: 'none',
                    display: 'flex',
                    alignItems: 'center'
                }}>
                    {/* <img src={Arrow} alt="Back" /> */}
                    <img src={Arrow} alt="Back" width='20px' style={{width: '30px', height: 'auto'}}/>
                    <span style={{ marginLeft: '5px', fontFamily: 'Manrope", sans-serif', fontSize: '16px' }}>Back</span>
            </Link>
            <div style={{ width: isMobile ? '100%' : '70%', margin:'50px auto 0px', backgroundColor: '#fff', borderRadius: '20px', boxShadow: '0px 4px 24px 0px #00000040', padding: isMobile ? '30px' : '50px 100px', textAlign: 'center', fontFamily: 'Manrope", sans-serif', fontSize: '20px' }}>
                <img src={Logo} alt="Logo" style={{ width: '30%', height: 'auto' }} />
                <h1 style={{ color: '#1F2933', fontFamily: 'Manrope", sans-serif', fontSize: '20px', fontWeight: '600', margin: '25px 0px 10px' }}>Select Your Role</h1>
                <p style={{ fontFamily: 'Manrope", sans-serif', color: '#4B556380', fontSize: '16px' }}>Choose how you'd like to use Oya.</p>
                <div style={{ width: '100%', display: isMobile ? 'block' : 'flex', justifyContent: 'space-between', marginTop: '30px' }}>
                    <RoleCard 
                        id="individual"
                        icon={IndividualIcon}
                        title="Individual"
                        description="Personal concierge services for your lifestyle needs."
                        isSelected={selectedRole === 'individual'}
                        onSelect={setSelectedRole}
                    />
                    <RoleCard 
                        id="corporate"
                        icon={CorporateIcon}
                        title="Corporate"
                        description="Manage employee benefits and corporate services at scale."
                        isSelected={selectedRole === 'corporate'}
                        onSelect={setSelectedRole}
                    />
                    <RoleCard 
                        id="vendor"
                        icon={VendorIcon}
                        title="Vendor"
                        description="List your services and reach verified clients."
                        isSelected={selectedRole === 'vendor'}
                        onSelect={setSelectedRole}
                    />
                    
                </div>
                <button 
                    onClick={handleContinue}
                    disabled={!selectedRole}
                    style={{
                        width: '100%',
                        padding: '16px',
                        borderRadius: '8px',
                        backgroundColor: selectedRole ? '#1A2238' : '#BFC4D1',
                        color: 'white',
                        border: 'none',
                        cursor: selectedRole ? 'pointer' : 'not-allowed',
                        marginTop: '40px',
                        fontFamily: 'Manrope", sans-serif',
                        fontSize: '20px',
                        fontWeight: '500'
                    }}
                    >
                    Continue
                    </button>
        
                    <p style={{ fontSize: '14px', color: '#4B5563', marginTop: '16px', fontFamily: 'Manrope", sans-serif', fontWeight: '400' }}>
                    You can switch roles later from your dashboard
                    </p>
            </div>
        </div>
        
    );
}